'use client';

import { useState, useEffect } from "react";
import styles from "./Navbar.module.css";
import { Link } from "react-router-dom";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : styles.transparent}`}>
            <div className={styles.inner}>
                <Link to="/" className={styles.logoLink}>
                    <img
                        src="/images/logo.png"
                        alt="Infinity Logo"
                        className={`${styles.logo} ${!scrolled ? styles.logoWhite : ''}`}
                    />
                </Link>

                <ul className={styles.menu}>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to={'/opportunity'}>Opportunity</Link></li>
                    <li><Link to="/services">Solutions & Expertise</Link></li>
                    <li><Link to={'/experience'}>Track Record & Expertise</Link></li>

                    {/* <li className={styles.hasDropdown}>
            <Link href="/healthcare-technology">
              Products <span className={styles.caret}>▾</span>
            </Link>
            <ul className={styles.dropdown}>
              <li><Link href="/healthcare-technology">Healthcare Products</Link></li>
              <li><Link href="/healthcare-technology">IT Solutions</Link></li>
              
            </ul>
          </li>    */}
                    <li><Link to="/team">Our Team</Link></li>

                </ul>

                <div className={styles.navEnd}>
                    <Link to="/contact" className={`${styles.ctaBtn} }`}>
                        Contact Us
                    </Link>
                    <button
                        className={styles.hamburger}
                        onClick={() => setMobileOpen(!mobileOpen)}
                        aria-label="Toggle menu"
                    >
                        <span className={`${styles.bar} ${mobileOpen ? styles.b1 : ''}`} />
                        <span className={`${styles.bar} ${mobileOpen ? styles.b2 : ''}`} />
                        <span className={`${styles.bar} ${mobileOpen ? styles.b3 : ''}`} />
                    </button>
                </div>
            </div>

            <div className={`${styles.mobileMenu} ${mobileOpen ? styles.mobileOpen : ''}`}>
                <Link to="/" onClick={() => setMobileOpen(false)}>Home</Link>
                {/* <Link to="/healthcare-technology" onClick={() => setMobileOpen(false)}>Healthcare Technology</Link> */}
                <Link to="/about" onClick={() => setMobileOpen(false)}>About Us</Link>
                <Link to="/opportunity" onClick={() => setMobileOpen(false)}>Opportunity</Link>
                <Link to="/services" onClick={() => setMobileOpen(false)}>Solutions & Expertise</Link>
                <Link to="/experience" onClick={() => setMobileOpen(false)}>Track Record & Expertise</Link>
                <Link to="/team" onClick={() => setMobileOpen(false)}>Our Team</Link>               
                
                
                <Link to="/contact" className={styles.mobileCta} onClick={() => setMobileOpen(false)}>Contact Us</Link>
            </div>
        </nav>
    );
}
